import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import { OperacoesAgendadasService } from './operacoes-agendadas.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NbDialogService } from '@nebular/theme';
import { ModalCancelAgendamentoComponent } from './modal-cancel-agendamento/modal-cancel-agendamento.component';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-operacoes-agendadas',
  templateUrl: './operacoes-agendadas.component.html',
  styleUrls: ['./operacoes-agendadas.component.scss']
})
export class OperacoesAgendadasComponent implements OnInit {

  public formAlterarSaldo = null;
  public saldoGlobal = null;
  public tableLimit = 10;
  public rowData = null;
  public user = null;
  public table: DatatableComponent;
  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public yesterday = new Date((new Date()).valueOf() - 1000*60*60*24);

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };

  constructor(
    private formBuilder: FormBuilder,
    private service: OperacoesAgendadasService,
    private notifications: NotificationsService,
    private paginationService: SpringDatatablePaginationService,
    private datatableService: DatatableService,
    private dialogService: NbDialogService,
    private router: Router,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.formAlterarSaldo = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
      saldo: [null],

    });

  }

  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  showCardModal(data: any) {

    this.dialogService.open(ModalCancelAgendamentoComponent, {
      context: {
        id: data.id,
        nome: data.nome,
        cpf: data.cpf,
        matricula: data.matricula,
      },
    });

  }

  buscarUser(data: any, nextPage?: any) {

    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit))

    if (data.cpf != null) {
      params = params.append('cpf', data.cpf);

    }
    if (data.matricula != null) {
      params = params.append('matricula', data.matricula);
    }

    if (nextPage) {
      params = params.append('page', String(nextPage))
    }

    this.service.agendarSaldo(params, (response => {

      this.rowData = response.content
      this.user = response.content.length;
      this.rowData = this.rowData.map(data => {
        return {
          id: data.id,
          nome: data.nome,
          cpf: data.cpf,
          matricula: data.matricula,
          status: data.status,
          saldo: data.saldo,
          dataAgendamento: moment(data.dataAgendamento).format('DD/MM/YYYY'),
        }
      })
      this.paginationService.setInfo(response);

      if (this.user == 0) {
        this.notifications.error(
          "Não existe agendamento para os filtros informados!"
        )
      }

    }), null);

  }

  ngOnInit() {
    this.datatableService.subscribeTable(this.table);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

}
